import styled from 'styled-components'
import { colors, fontSizes, fontWeights, breakpoints } from '@/styles'

const ItemContainer = styled.div`
  object-fit: cover;
  width: 200px;
  height: 175px;
  position: relative;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: 156px;
    height: 156px;
  }
`

export const UploadPlaceholder = styled(ItemContainer)`
  border: 1px dashed #a5a5a5;
  border-radius: 6px;
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.39px;
  line-height: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  svg {
    margin-bottom: 20px;
  }

  ${props =>
    props.disabled &&
    `
    cursor: default;
    opacity: 0.5;
  `}
`

export default ItemContainer
